import {Button, Col, Form, Input, message, Row} from "antd";
import {FC} from "react";
import {useHistory} from "react-router-dom";
import ContactPersonsFieldList from "../../../components/form/contactPersonsFieldList";
import DividerLine from "../../../components/lineSplit";
import {renderErrorMessage} from "../../../components/messages/errorMessage";
import SavedMessage from "../../../components/messages/savedMessage";
import CustomerStore from "../../../contexts/customerStore";
import _t from "../../../lang/translate";
import {getPath} from "../../../routes/appRoutes";
import {updateCustomer} from "../../../services/customerService";
import {CustomerType} from "../../../types/customerTypes";
import consts from "../../../utilities/consts";
import {isAxiosError} from "../../../utilities/typeGuard";
import CustomerFormFields from "./customerFormFields";
import UserStore from "../../../contexts/userStore";

interface CustomerInfoFormProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  stopEditing: () => void;
}

const CustomerInfoForm: FC<CustomerInfoFormProps> = ({ setLoading, stopEditing }) => {
  let history = useHistory();
  const { customer, isPrivate, isNew, setCustomer } = CustomerStore.useContainer();
  const [customerForm] = Form.useForm();

  const { hasPermission } = UserStore.useContainer();
  const isAdmin = hasPermission("tax.isAdmin");

  const handleSave = async (values: CustomerType) => {
    try {
      setLoading(true);
      const { data } = await updateCustomer<CustomerType>({ ...customer, ...values });
      message.success(<SavedMessage message={_t("saved")} />);
      if (isNew) {
        history.replace(getPath("customer", data.id));
      } else {
        stopEditing();
        setCustomer(data);
        setLoading(false);
      }
    } catch (error) {
      if (isAxiosError(error)) {
        const errors = error.response?.data?.errors;
        errors && customerForm.setFields(errors);
      }
      renderErrorMessage(error)
      setLoading(false);
    }
  };

  return (
    <Form initialValues={customer} form={customerForm} {...consts.formItemProps} onFinish={handleSave} className="mb-0">
      <CustomerFormFields isPrivate={isPrivate} disableCVR={!isNew} />
      {!isPrivate && (
        <>
          <DividerLine />
          <ContactPersonsFieldList />
        </>
      )}
      {isAdmin && (
        <>
          <DividerLine />
          <Form.Item
            label={_t("customer", "note")}
            name={["note"]}
            wrapperCol={{ span: 24 }}
            labelCol={{ span: 24 }}
          >
            <Input.TextArea autoSize={{ minRows: 4 }} />
          </Form.Item>
        </>
      )}

      <Form.Item noStyle shouldUpdate>
        {({ submit }) =>
          isNew ? (
            <div className="text-right mt-2">
              <Button type="primary" onClick={submit}>
                {_t("create", "customer")}
              </Button>
            </div>
          ) : (
            <Row justify="space-between" className="mt-2">
              <Col>
                <Button onClick={stopEditing}>{_t("cancel")}</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={submit}>
                  {_t("save")}
                </Button>
              </Col>
            </Row>
          )
        }
      </Form.Item>
    </Form>
  );
};

export default CustomerInfoForm;
